import { Component, Input, OnInit } from '@angular/core';
import { ApiPathsService } from "../../api-paths.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SerialeComponent } from '../seriale/seriale.component';
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { Title } from '@angular/platform-browser';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
    templateUrl: 'seriali-list.component.html',
    styleUrls: ['./seriali-list-component.scss']
})
export class SerialiListComponent implements OnInit {
    private inputEventSubject: Subject<Event> = new Subject();
    openModal = false;
    serialiList: any[];
    tipo: String;
    filtro: any = {};
    constructor(private apiPaths: ApiPathsService, private activateRoute: ActivatedRoute, private modalService: NgbModal, private datePipe: DatePipe, private toastService: ToastrService, private titleService: Title) {

    }
    ngOnInit() {
        this.inputEventSubject.pipe(
            debounceTime(500)
        ).subscribe(event => {
            this.handleDebouncedInput(event);
        });
        this.activateRoute.params.subscribe(
            data => {
                this.tipo = data['type'];
                switch (this.tipo) {
                    case ('AT'):
                        setTimeout(() => { this.titleService.setTitle('Attrezzatura'); }, 200)
                        break;
                    case ('SM'):
                        setTimeout(() => { this.titleService.setTitle('Strumenti di Misura'); }, 200)
                        break;
                    case ('IN'):
                        setTimeout(() => { this.titleService.setTitle('Infrastruttura'); }, 200)
                        break;
                }
                this.Refresh();
            }
        )
    }

    addSeriale() {
        var modal = this.modalService.open(SerialeComponent, {
            centered: true,
            backdrop: 'static',
            size: 'xl',
        });
        (<SerialeComponent>modal.componentInstance).seriale = { tipo: this.tipo, dataAcquisto: this.datePipe.transform(new Date(), 'yyyy-MM-dd') };
        (<SerialeComponent>modal.componentInstance).refreshList.subscribe((data) => { this.Refresh() })
    };

    onInput(event: Event): void {
        this.inputEventSubject.next(event);
    }

    handleDebouncedInput(event: Event): void {
        console.log('Evento debounced:', event);
        this.Refresh();
    }


    Refresh() {
        this.apiPaths.ClassicPost('/task/seriale/list', { tipo: this.tipo, seriale: this.filtro.nome }).subscribe(
            data => {
                this.serialiList = data.data;
            }
        )
    }

    openEdit(seriale: any) {
        var modal = this.modalService.open(SerialeComponent, {
            centered: true,
            backdrop: 'static',
            size: 'xl',
        });
        (<SerialeComponent>modal.componentInstance).seriale = seriale;
        (<SerialeComponent>modal.componentInstance).refreshList.subscribe((data) => { console.log('Refresho'); this.Refresh() });
    }

    deleteSeriale(seriale: any) {
        if (confirm("Sicuro di voler eliminare questo elemento dalla lista?"))
            this.apiPaths.ClassicPost('/task/seriale/delete', { id: seriale?.id }).subscribe(
                data => {
                    this.toastService.success("Elemento rimosso con successo");
                    this.Refresh();
                }
            )
    }


}
